export default {
//    BaseURL: 'http://localhost:8085/api/v1',
//    WSURL: 'localhost:8085'
//    BaseURL: 'https://swimlor.stream.netlor.fr/api/v1'
    BaseURL: (process.env.VUE_APP_API_HOST || '') + '/api/v1',
    ServerURL: new URL(process.env.VUE_APP_API_HOST || window.location.origin),
    WSURL: process.env.VUE_APP_API_HOST ?? window.location.host
}
